import { render } from "./HeroiconsOutlineAnnotation.vue?vue&type=template&id=240da2c0"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineAnnotation.vue"]])

export default __exports__